import { render, staticRenderFns } from "./AccountPlanHeader.vue?vue&type=template&id=c447af9a&scoped=true"
import script from "./AccountPlanHeader.vue?vue&type=script&lang=js"
export * from "./AccountPlanHeader.vue?vue&type=script&lang=js"
import style0 from "./AccountPlanHeader.vue?vue&type=style&index=0&id=c447af9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c447af9a",
  null
  
)

export default component.exports